(ns common.schema.entities.integration.nylas-account
  (:require [common.schema.schema-utils :as su]))

(def schema
  (vec (concat
         ;; DEPRECATED FIELDS
        (su/text-simple-field :nylas-account/sync-state
                              "Sync state"
                              {:authorization    su/access-user-user
                               :deprecated?      true
                               :system-semantics su/system-controlled-optional-field-semantics})

         ;; from Nylas
        (su/text-simple-field :nylas-account/email
                              "Email address"
                              {:authorization    su/access-user-user
                               :system-semantics su/system-controlled-optional-field-semantics})
        (su/text-simple-field :nylas-account/id
                              "ID"
                              {:authorization    su/access-user-user
                               :system-semantics su/system-controlled-optional-field-semantics})
        (su/text-simple-field :nylas-account/name
                              "Name"
                              {:authorization    su/access-user-user
                               :system-semantics su/system-controlled-optional-field-semantics})
        (su/text-simple-field :nylas-account/object
                              "Object"
                              {:authorization    su/access-user-user
                               :system-semantics su/system-controlled-optional-field-semantics})
        (su/text-simple-field :nylas-account/organization-unit
                              "Organization unit"
                              {:authorization    su/access-user-user
                               :system-semantics su/system-controlled-optional-field-semantics})
        (su/text-simple-field :nylas-account/provider
                              "Provider"
                              {:authorization    su/access-user-user
                               :system-semantics su/system-controlled-optional-field-semantics})
        (su/integer-field :nylas-account/linked-at
                          "Linked at"
                          {:authorization    su/access-user-user
                           :system-semantics su/system-controlled-optional-field-semantics})

         ;; from Nylas - protected fields
        (su/text-simple-field :nylas-account/token
                              "Token"
                              {:authorization    su/access-system-system
                               :system-semantics su/system-controlled-optional-field-semantics})
        (su/text-simple-field :nylas-account/token-type
                              "Token type"
                              {:authorization    su/access-system-system
                               :system-semantics su/system-controlled-optional-field-semantics})

         ;; V3 - Access control & lifecycle
        (su/boolean-field :nylas-account/expired?
                          "Expired"
                          {:authorization    su/access-user-user
                           :system-semantics su/system-controlled-optional-field-semantics}))))
